/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Proof_1Inputs */

const en_mk_proof_1 = /** @type {(inputs: Mk_Proof_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every task carries pass/fail criteria, written into the PRD before a line of code exists.`)
};

const id_mk_proof_1 = /** @type {(inputs: Mk_Proof_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiap task membawa kriteria lulus/gagal, ditulis di PRD sebelum ada satu baris kode.`)
};

/**
* | output |
* | --- |
* | "Every task carries pass/fail criteria, written into the PRD before a line of code exists." |
*
* @param {Mk_Proof_1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_proof_1 = /** @type {((inputs?: Mk_Proof_1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Proof_1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_proof_1(inputs)
	return en_mk_proof_1(inputs)
});